module.exports = __webpack_public_path__ + "img/35.4a7e3d0d.jpg";